import React, { Component } from "react";

import "./StoryContainer.scss"

class StoryContainer extends Component {
  constructor() {
    super();
    this.state = {
      currItem: []
    }
  }
  componentDidMount() {
    this.setState({
      currItem: this.props.item
    })
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      currItem: nextProps.item
    })
  }
  render() {
    const itemImage = {
      backgroundImage: `url(./static/images/${(window.screen.width >= 1000 ? "desktop" : "mobile")}/mustknow/${this.state.currItem.image}`
    }
    return (
      <article>
        <div className="padding">
          <div className="container">
            <div className="image" style={itemImage}>
              <div className="teaser">
                <div className="desc">
                  <h4>
                    {this.state.currItem.name}
                  </h4>
                  <h5>
                    {this.state.currItem.desc}
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </article>
    );
  }
}

export default StoryContainer;



// WEBPACK FOOTER //
// ./src/Components/MustKnow/StoryContainer.js